import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";

import { BrandChipContainer } from "./BrandChipContainer";

export interface IAddBrandsButton {
    unselectedBrands: string[];
    onAddBrand: (brand: string) => void;
}

export const AddBrandsButton = ({ unselectedBrands, onAddBrand }: IAddBrandsButton) => {
    return (
        <BrandChipContainer
            unselectedBrands={unselectedBrands}
            onItemClick={onAddBrand}
        >
            <IconButton
                data-automation="add-brands-button"
                iconSize="10px"
                iconName="plus"
                type={buttonTypes.FLAT}
            >
                {translate("common.add")}
            </IconButton>
        </BrandChipContainer>
    );
};
